import { fetchRequest } from "../Fetcher";
import { pollJobUntilDone } from "./PollJobUntilDone";

export const runSceneImageGenerationJob = async ({
  storyboardId,
  sceneId,
  body,
}) => {
  const { result } = await fetchRequest({
    path: `sessions/storyboards/${storyboardId}/scenes/${sceneId}/scene-image/generate`,
    method: "POST",
    data: JSON.stringify(body),
  });

  const jobId =
    result?.job_id ??
    result?.jobId ??
    result?.data?.job_id ??
    result?.data?.jobId;

  if (!jobId) {
    return result;
  }

  const finalResult = await pollJobUntilDone({
    getStatus: () =>
      fetchRequest({
        path: `sessions/jobs/${jobId}`,
        method: "GET",
      }),
  });

  return finalResult;
};